<ng-container *ngIf="state$ | async; let state">
    <div class="zas-row">
        <zbd-tabbar
            [showValidIndicators]="false"
            class="zas-main-col"
            [switchStrategy]="'event'"
            (switch)="
                persistence.updateProtocol(
                    state.protocol,
                    'Occasion',
                    $event.tabCode,
                    true
                )
            "
        >
            <zbd-tab
                [tabTitle]="Constants.Produktbezogen.viewValue"
                [active]="state.protocol.Occasion === 'PRODUCT'"
                [tabCode]="'PRODUCT'"
            >
                <br />
                <zbd-product-occasion></zbd-product-occasion>
            </zbd-tab>
            <zbd-tab
                [tabTitle]="Constants.Anlassbezogen.viewValue"
                [active]="state.protocol.Occasion === 'OCCASION'"
                [tabCode]="'OCCASION'"
            >
                <br />
                <zbd-occasion-occasion></zbd-occasion-occasion>
            </zbd-tab>
            <zbd-tab
                [tabTitle]="Constants.Komplett.viewValue"
                [active]="state.protocol.Occasion === 'GLOBAL'"
                [tabCode]="'GLOBAL'"
            >
                <br />
                <zbd-global-occasion></zbd-global-occasion>
            </zbd-tab>
        </zbd-tabbar>
    </div>
</ng-container>
